import type React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft, Link2 } from 'lucide-react';
import { ArticleBriefForm } from './ArticleBriefForm';
import type { ArticleBrief } from '../types/article-brief';

interface ManualSourceFlowProps {
  onBack: () => void;
}

export const ManualSourceFlow: React.FC<ManualSourceFlowProps> = ({
  onBack
}) => {
  const navigate = useNavigate();

  const handleFormNext = (data: ArticleBrief) => {
    // After successful save, navigate to brief detail page (matches DeepResearchFlow behavior)
    navigate(`/brief/${data.id}`);
  };

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Link2 className="h-6 w-6 text-primary" />
            Bring Your Own Sources
          </h1>
          <p className="text-muted-foreground mt-1">
            Manually provide URLs and research materials for your article
          </p>
        </div>
        <Button variant="outline" onClick={onBack}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
      </div>

      {/* Reuse the existing form in create mode */}
      <ArticleBriefForm
        mode="create"
        onNext={handleFormNext}
        onBack={onBack}
      />
    </div>
  );
};